import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CustomIconComponent} from './components/custom-icon/custom-icon.component';
import {NzIconDirective} from 'ng-zorro-antd/icon';
import {SidebarComponent} from './components/sidebar/sidebar.component';
import {
    NzMenuDirective,
    NzMenuDividerDirective,
    NzMenuGroupComponent,
    NzMenuItemComponent,
    NzSubMenuComponent
} from "ng-zorro-antd/menu";
import {NzSiderComponent} from "ng-zorro-antd/layout";
import {NzAvatarComponent} from 'ng-zorro-antd/avatar';
import {NzBadgeComponent} from 'ng-zorro-antd/badge';
import {NzDropDownDirective, NzDropdownMenuComponent} from 'ng-zorro-antd/dropdown';
import {NzButtonComponent} from "ng-zorro-antd/button";
import {RouterLink, RouterLinkActive} from "@angular/router";
import {ProjectStatePipe} from './pipes/project-state.pipe';
import {CollapsePanelHeaderComponent} from './components/collapse-panel-header/collapse-panel-header.component';
import {ActionBtnsComponent} from './components/action-btns/action-btns.component';
import {InfoCardComponent} from './components/info-card/info-card.component';
import {NzCardComponent} from 'ng-zorro-antd/card';
import {NzSpinComponent} from 'ng-zorro-antd/spin';
import {NzDividerComponent} from 'ng-zorro-antd/divider';
import {PlaceIconPipe} from './pipes/place-icon.pipe';
import {NzProgressComponent} from 'ng-zorro-antd/progress';
import {ListKeyValueComponent} from './components/list-key-value/list-key-value.component';
import {ChatComponent} from './components/chat/chat.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NzAutosizeDirective, NzInputDirective, NzInputGroupComponent} from 'ng-zorro-antd/input';
import {DocStatePipe} from './pipes/doc-state.pipe';
import {NotFoundComponent} from './components/not-found/not-found.component';
import {NzCommentComponent, NzCommentContentDirective} from 'ng-zorro-antd/comment';
import {RelativeDatePipe} from './pipes/relative-date.pipe';
import {MarkAsReadDirective} from './directives/mark-as-read.directive';
import {DocModalComponent} from './components/doc-modal/doc-modal.component';
import {NzUploadComponent} from "ng-zorro-antd/upload";
import {NzOptionComponent, NzSelectComponent} from 'ng-zorro-antd/select';
import {ToastComponent} from './components/toast/toast.component';
import {NzCollapseComponent, NzCollapsePanelComponent} from 'ng-zorro-antd/collapse';
import {NzDatePickerComponent} from "ng-zorro-antd/date-picker";
import {AutoWidthDirective} from './directives/auto-width.directive';
import {EmptyStateComponent} from './components/emty-state/empty-state.component';
import {NzCheckboxComponent} from "ng-zorro-antd/checkbox";
import {AuthCallbackComponent} from './components/auth-callback/auth-callback.component';
import {AuthErrorComponent} from './components/auth-error/auth-error.component';
import {NzMentionComponent, NzMentionSuggestionDirective, NzMentionTriggerDirective} from "ng-zorro-antd/mention";
import {ServiceOrderStatePipe} from './pipes/service-order-state.pipe';
import {MentionTransformPipe} from './pipes/mention-transform.pipe';
import {OrderStatePipe} from './pipes/order-state.pipe';
import {MojitoIntegrationStatusPipe} from './pipes/mojito-integration-status.pipe';
import {DocInfoCardComponent} from './components/doc-info-card/doc-info-card.component';
import {DocDrawerComponent} from './components/doc-drawer/doc-drawer.component';
import {FlowEventCardComponent} from './components/event-cards-dragables/flow-event-card.component';
import {CdkDrag, CdkDragHandle, CdkDropList} from '@angular/cdk/drag-drop';
import {EventActivatorSectionComponent} from './components/event-activator-section/event-activator-section.component';
import {NzColDirective, NzRowDirective} from 'ng-zorro-antd/grid';
import {NzFormControlComponent, NzFormDirective, NzFormItemComponent, NzFormLabelComponent} from 'ng-zorro-antd/form';
import {SplitBtnComponent} from './components/split-btn/split-btn.component';
import {NzSpaceComponent} from "ng-zorro-antd/space";
import {CreateDocFormCardComponent} from './components/create-doc-form-card/create-doc-form-card.component';
import {AvatarBadgeComponent} from './components/avatar-badge/avatar-badge.component';
import {AvatarSelectComponent} from './components/avatar-select/avatar-select.component';
import {AvatarMultiselectComponent} from './components/avatar-multiselect/avatar-multiselect.component';
import { PocketSearchbarComponent } from './components/pocket-searchbar/pocket-searchbar.component';
import {InputNumberDirective} from './directives/number-input.directive';
import { DocBadgetStatusComponent } from './components/doc-badget-status/doc-badget-status.component';
import {NzTooltipDirective} from "ng-zorro-antd/tooltip";
import { RateDotChartComponent } from './components/rate-dot-chart/rate-dot-chart.component';
import { WarningAreaComponent } from './components/warning-area/warning-area.component';
import {NzSkeletonComponent} from "ng-zorro-antd/skeleton";
import {NzModalModule} from "ng-zorro-antd/modal";
import { StThSortComponent } from './components/st-th-sort/st-th-sort.component';
import { ConfirmationModalComponent } from './components/confirmation-modal/confirmation-modal.component';
import {ContainerAdvancedSearchComponent} from './components/container-advanced-search/container-advanced-search.component';
import {NzEmptyComponent} from 'ng-zorro-antd/empty';
import {ServiceFlowWarningComponent} from './components/service-flow-warning/service-flow-warning.component';


@NgModule({
  declarations: [
    CustomIconComponent,
    SidebarComponent,
    CollapsePanelHeaderComponent,
    ActionBtnsComponent,
    InfoCardComponent,
    ListKeyValueComponent,
    ChatComponent,
    DocStatePipe,
    NotFoundComponent,
    RelativeDatePipe,
    DocModalComponent,
    ToastComponent,
    EmptyStateComponent,
    AuthCallbackComponent,
    AuthErrorComponent,
    ServiceOrderStatePipe,
    MentionTransformPipe,
    OrderStatePipe,
    MojitoIntegrationStatusPipe,
    DocInfoCardComponent,
    DocDrawerComponent,
    FlowEventCardComponent,
    EventActivatorSectionComponent,
    SplitBtnComponent,
    CreateDocFormCardComponent,
    AvatarBadgeComponent,
    AvatarSelectComponent,
    AvatarMultiselectComponent,
    PocketSearchbarComponent,
    InputNumberDirective,
    DocBadgetStatusComponent,
    RateDotChartComponent,
    WarningAreaComponent,
    StThSortComponent,
    ConfirmationModalComponent,
    ContainerAdvancedSearchComponent,
    ServiceFlowWarningComponent,
  ],
    exports: [
        CustomIconComponent,
        SidebarComponent,
        CollapsePanelHeaderComponent,
        InfoCardComponent,
        ListKeyValueComponent,
        ChatComponent,
        ActionBtnsComponent,
        DocStatePipe,
        RelativeDatePipe,
        ToastComponent,
        EmptyStateComponent,
        ServiceOrderStatePipe,
        OrderStatePipe,
        MojitoIntegrationStatusPipe,
        DocInfoCardComponent,
        DocDrawerComponent,
        MentionTransformPipe,
        FlowEventCardComponent,
        EventActivatorSectionComponent,
        SplitBtnComponent,
        CreateDocFormCardComponent,
        DocModalComponent,
        AvatarBadgeComponent,
        AvatarSelectComponent,
        AvatarMultiselectComponent,
        PocketSearchbarComponent,
        InputNumberDirective,
        DocBadgetStatusComponent,
        RateDotChartComponent,
        WarningAreaComponent,
        StThSortComponent,
        ConfirmationModalComponent,
        ContainerAdvancedSearchComponent,
        ServiceFlowWarningComponent,
    ],
    imports: [
        CommonModule,
        NzIconDirective,
        NzMenuDirective,
        NzMenuItemComponent,
        NzSiderComponent,
        NzAvatarComponent,
        NzBadgeComponent,
        NzDropDownDirective,
        NzDropdownMenuComponent,
        NzButtonComponent,
        RouterLink,
        RouterLinkActive,
        ProjectStatePipe,
        NzCardComponent,
        NzSpinComponent,
        NzDividerComponent,
        PlaceIconPipe,
        NzProgressComponent,
        FormsModule,
        NzInputDirective,
        NzInputGroupComponent,
        NzCommentComponent,
        NzCommentContentDirective,
        MarkAsReadDirective,
        NzUploadComponent,
        NzSelectComponent,
        NzOptionComponent,
        NzAutosizeDirective,
        NzCollapsePanelComponent,
        NzCollapseComponent,
        NzDatePickerComponent,
        AutoWidthDirective,
        NzCheckboxComponent,
        NzMenuGroupComponent,
        NzSubMenuComponent,
        NzMentionComponent,
        NzMentionTriggerDirective,
        NzMentionSuggestionDirective,
        CdkDrag,
        CdkDragHandle,
        CdkDropList,
        NzColDirective,
        NzFormControlComponent,
        NzFormDirective,
        NzFormItemComponent,
        NzFormLabelComponent,
        NzRowDirective,
        ReactiveFormsModule,
        NzSpaceComponent,
        NzMenuDividerDirective,
        NzTooltipDirective,
        NzSkeletonComponent,
        NzModalModule,
        NzEmptyComponent,
    ]
})
export class SharedModule {
}
